:host {
  --aha-sidepanel--menu-width: 380px;
  --aha-sidepanel--pull-tab-width: 40px;
  --aha-sidepanel--container-width: calc(
    var(--aha-sidepanel--menu-width) + var(--aha-sidepanel--pull-tab-width)
  );
  --aha-sidepanel--header-height: 60px;
}

#container {
  position: relative;
  top: 0;
  right: 0;
  display: flex;
  max-width: 100%;
  height: 100%;
  pointer-events: none;
}

#container.open .content {
  width: var(--aha-sidepanel--menu-width);
}

#container.open .shadow-layer {
  width: var(--aha-sidepanel--menu-width);
  box-shadow: var(--theme-shadow-shallow);
}

#container.open slot[name='pull-tabs'] {
  display: none;
}

#container.resizing .content,
#container.resizing .shadow-layer {
  transition: none !important;
}

.content {
  position: relative;
  z-index: 103;
  width: 0;
  background-color: var(--theme-primary-background);
  transition: all 0.3s ease;
  overflow: hidden;
  pointer-events: auto;
}

.shadow-layer {
  position: absolute;
  z-index: 100;
  width: 0;
  height: 100%;
  top: 0;
  right: 0;
  background-color: transparent;
  transition: all 0.3s ease;
  pointer-events: none;
}

.content-wrapper {
  width: var(--aha-sidepanel--menu-width);
}

.pull-tabs {
  position: relative;
  z-index: 102;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: var(--aha-sidepanel--pull-tab-width);
  height: auto;
  margin-top: var(--aha-sidepanel--header-height);
  background-color: var(--theme-primary-background);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  box-shadow: var(--theme-shadow-shallow);
  pointer-events: auto;
  clip-path: inset(-10px 0px -10px -10px);
}

.rounded-edge {
  width: 8px;
  height: 8px;
  right: 0;
  position: absolute;
  color: var(--theme-primary-background);
}

.rounded-edge--top {
  top: -8px;
}

.rounded-edge--bottom {
  bottom: -8px;
}

.main-pull-tab {
  transition: transform 0.3s ease;
}

.rotated {
  transform: rotate(180deg);
}

.resize-handle {
  position: absolute;
  left: -5px;
  top: 0;
  width: 9px;
  height: 100%;
  cursor: ew-resize;
  z-index: 104;
  transition: background-image 0.3s ease;
  --sidepanel-drag-handle-color: var(--aha-blue-500);
}

.resize-handle:hover,
#container.resizing .resize-handle {
  background-image: linear-gradient(
    to right,
    transparent 0px 2px,
    var(--sidepanel-drag-handle-color) 3px 6px
  );
  opacity: 0.4;
  width: 6px;
  left: -3px;
}
